export default __webpack_public_path__ + "assets/images/03154fa62310dc1a127b3d3ecb974124-natural_formulas.svg";